// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 60vh;
  text-align: center;
}
.dialog-title {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.steps-action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom {
  bottom: 0px;
  position: relative;
}
.steps-action {
  margin-top: 24px;
  margin-bottom: 15px;
}

button {
  margin-right: 8px;
}

[nz-button] {
  margin-right: 8px;
  margin-bottom: 12px;
}
[nz-form] {
  max-width: 60vh;
}
/* nz-steps {
    margin-bottom: 8px;
    box-shadow: rgb(232, 232, 232) 0px -1px 0px 0 inset;
  } */

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFzc2Vzc21lbnRtb2RhbC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZ0JBQWdCO0VBQ2hCLDBCQUEwQjtFQUMxQixrQkFBa0I7RUFDbEIseUJBQXlCO0VBQ3pCLGdCQUFnQjtFQUNoQixrQkFBa0I7QUFDcEI7QUFDQTtFQUNFLGFBQWE7RUFDYix5QkFBeUI7RUFDekIscUJBQXFCO0FBQ3ZCO0FBQ0E7RUFDRSxhQUFhO0VBQ2IsbUJBQW1CO0VBQ25CLHVCQUF1QjtBQUN6QjtBQUNBO0VBQ0UsV0FBVztFQUNYLGtCQUFrQjtBQUNwQjtBQUNBO0VBQ0UsZ0JBQWdCO0VBQ2hCLG1CQUFtQjtBQUNyQjs7QUFFQTtFQUNFLGlCQUFpQjtBQUNuQjs7QUFFQTtFQUNFLGlCQUFpQjtFQUNqQixtQkFBbUI7QUFDckI7QUFDQTtFQUNFLGVBQWU7QUFDakI7QUFDQTs7O0tBR0siLCJmaWxlIjoiYXNzZXNzbWVudG1vZGFsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc3RlcHMtY29udGVudCB7XG4gIG1hcmdpbi10b3A6IDE2cHg7XG4gIGJvcmRlcjogMXB4IGRhc2hlZCAjZTllOWU5O1xuICBib3JkZXItcmFkaXVzOiA2cHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmYWZhZmE7XG4gIG1pbi1oZWlnaHQ6IDYwdmg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbi5kaWFsb2ctdGl0bGUge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICBhbGlnbi1pdGVtczogZmxleC1lbmQ7XG59XG4uc3RlcHMtYWN0aW9uLWJ1dHRvbnMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbn1cbi5ib3R0b20ge1xuICBib3R0b206IDBweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuLnN0ZXBzLWFjdGlvbiB7XG4gIG1hcmdpbi10b3A6IDI0cHg7XG4gIG1hcmdpbi1ib3R0b206IDE1cHg7XG59XG5cbmJ1dHRvbiB7XG4gIG1hcmdpbi1yaWdodDogOHB4O1xufVxuXG5bbnotYnV0dG9uXSB7XG4gIG1hcmdpbi1yaWdodDogOHB4O1xuICBtYXJnaW4tYm90dG9tOiAxMnB4O1xufVxuW256LWZvcm1dIHtcbiAgbWF4LXdpZHRoOiA2MHZoO1xufVxuLyogbnotc3RlcHMge1xuICAgIG1hcmdpbi1ib3R0b206IDhweDtcbiAgICBib3gtc2hhZG93OiByZ2IoMjMyLCAyMzIsIDIzMikgMHB4IC0xcHggMHB4IDAgaW5zZXQ7XG4gIH0gKi9cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/assessment/modal/assessmentmodal.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;;;KAGK;;AAEL,ooDAAooD","sourcesContent":[".steps-content {\n  margin-top: 16px;\n  border: 1px dashed #e9e9e9;\n  border-radius: 6px;\n  background-color: #fafafa;\n  min-height: 60vh;\n  text-align: center;\n}\n.dialog-title {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n.steps-action-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.bottom {\n  bottom: 0px;\n  position: relative;\n}\n.steps-action {\n  margin-top: 24px;\n  margin-bottom: 15px;\n}\n\nbutton {\n  margin-right: 8px;\n}\n\n[nz-button] {\n  margin-right: 8px;\n  margin-bottom: 12px;\n}\n[nz-form] {\n  max-width: 60vh;\n}\n/* nz-steps {\n    margin-bottom: 8px;\n    box-shadow: rgb(232, 232, 232) 0px -1px 0px 0 inset;\n  } */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
